import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Table } from 'react-bootstrap';
import { api } from "../../services/api";
import Swal from "sweetalert2";
import { FaSave, FaSearch } from "react-icons/fa";

export default function ModalLancamentoManual({ show, onHide }) {
    const [loading, setLoading] = useState(false);
    const [lancamentos, setLancamentos] = useState([]);
    const [lookups, setLookups] = useState({ roteamentos: [], bandeiras: [], condicoes: [] });
    
    const [form, setForm] = useState({
        roteamento: '', bandeira: '', condicao: '', loja: '',
        datavenda: new Date().toISOString().split('T')[0],
        datacredito: new Date().toISOString().split('T')[0],
        valorbruto: '', taxaflor: 0
    });

    const [filtros, setFiltros] = useState({
        dtini: new Date().toISOString().split('T')[0],
        dtfim: new Date().toISOString().split('T')[0]
    });

    useEffect(() => {
        if (show) {
            api.get('/financeiro/conciliacao/roteamentos')
                .then(res => setLookups(prev => ({ ...prev, roteamentos: res.data })))
                .catch(err => console.error("Erro roteamentos:", err));
        }
    }, [show]);

    // Função idêntica à do exemplo que funciona
    const renderOptions = (lista, campo) => {
        return lista.map((item, index) => {
            const valor = typeof item === 'object' ? item[campo] : item;
            return <option key={index} value={valor}>{valor}</option>;
        });
    };

    const atualizarLista = async () => {
        // Verifica se os campos de busca estão preenchidos (usando nomes do estado do form)
        if (!form.roteamento || !form.bandeira || !form.condicao) return;
        try {
            const res = await api.post('/financeiro/conciliacao/manual/listar', {
                dtini: filtros.dtini.split('-').reverse().join('/'),
                dtfim: filtros.dtfim.split('-').reverse().join('/'),
                roteamento: form.roteamento,
                bandeira: form.bandeira,
                condicao: form.condicao
            });
            setLancamentos(res.data);
        } catch (err) { console.error(err); }
    };

    const handleSalvar = async () => {
        if (!form.roteamento || !form.loja || !form.valorbruto) {
            Swal.fire("Erro", "Preencha os campos obrigatórios", "error");
            return;
        }
        setLoading(true);
        try {
            await api.post('/financeiro/conciliacao/manual', form);
            Swal.fire("Sucesso", "Lançamento realizado!", "success");
            atualizarLista();
            setForm({ ...form, valorbruto: '' });
        } catch (err) {
            Swal.fire("Erro", "Falha ao salvar", "error");
        } finally { setLoading(false); }
    };

    const handleRoteamento = async (val) => {
        setForm({ ...form, roteamento: val, bandeira: '', condicao: '', taxaflor: 0 });
        if (!val) return;
        try {
            const res = await api.get(`/financeiro/conciliacao/bandeiras?roteamento=${val}`);
            setLookups(prev => ({ ...prev, bandeiras: res.data, condicoes: [] }));
        } catch (err) { console.error(err); }
    };

    const handleBandeira = async (val) => {
        setForm(prev => ({ ...prev, bandeira: val, condicao: '', taxaflor: 0 }));
        if (!val) return;
        try {
            const res = await api.get(`/financeiro/conciliacao/condicoes?roteamento=${form.roteamento}&bandeira=${val}`);
            setLookups(prev => ({ ...prev, condicoes: res.data }));
        } catch (err) { console.error(err); }
    };

    const handleCondicao = async (val) => {
        if (!val) return;
        try {
            const res = await api.get(`/financeiro/conciliacao/taxa?roteamento=${form.roteamento}&bandeira=${form.bandeira}&condicao=${val}`);
            // Note que aqui usamos .taxa ou .TAXA dependendo do seu retorno de objeto único
            const valorTaxa = res.data.TAXA || res.data.taxa || 0;
            setForm(prev => ({ ...prev, condicao: val, taxaflor: valorTaxa }));
        } catch (err) { console.error(err); }
    };

    return (
        <Modal show={show} onHide={onHide} size="xl" centered scrollable>
            <Modal.Header closeButton className="bg-primary text-white p-2">
                <Modal.Title className="small fw-bold ms-2">LANÇAMENTO MANUAL</Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-light">
                <div className="card p-3 shadow-sm border-0 mb-3">
                    <Row className="g-2">
                        <Col md={3}>
                            <label className="small fw-bold">Roteamento</label>
                            <Form.Select size="sm" value={form.roteamento} onChange={e => handleRoteamento(e.target.value)}>
                                <option value="">Selecione...</option>
                                {renderOptions(lookups.roteamentos, 'ROTEAMENTO')}
                            </Form.Select>
                        </Col>
                        <Col md={3}>
                            <label className="small fw-bold">Bandeira</label>
                            <Form.Select size="sm" value={form.bandeira} onChange={e => handleBandeira(e.target.value)} disabled={!form.roteamento}>
                                <option value="">Selecione...</option>
                                {renderOptions(lookups.bandeiras, 'BANDEIRA')}
                            </Form.Select>
                        </Col>
                        <Col md={3}>
                            <label className="small fw-bold">Condição</label>
                            <Form.Select size="sm" value={form.condicao} onChange={e => handleCondicao(e.target.value)} disabled={!form.bandeira}>
                                <option value="">Selecione...</option>
                                {renderOptions(lookups.condicoes, 'CONDICAO')}
                            </Form.Select>
                        </Col>
                        <Col md={3}>
                            <label className="small fw-bold">Loja</label>
                            <Form.Control size="sm" type="number" value={form.loja} onChange={e => setForm({...form, loja: e.target.value})} />
                        </Col>
                        <Col md={3}>
                            <label className="small fw-bold">Valor Bruto</label>
                            <Form.Control size="sm" type="number" value={form.valorbruto} onChange={e => setForm({...form, valorbruto: e.target.value})} />
                        </Col>
                        <Col md={2}>
                            <label className="small fw-bold text-danger">Taxa (%)</label>
                            <div className="form-control form-control-sm bg-white fw-bold text-center">{form.taxaflor}%</div>
                        </Col>
                        <Col md={2} className="d-flex align-items-end">
                            <Button variant="success" size="sm" className="w-100 fw-bold" onClick={handleSalvar} disabled={loading}>
                                <FaSave className="me-2"/> GRAVAR
                            </Button>
                        </Col>
                    </Row>
                </div>

                <div className="card p-2 shadow-sm border-0">
                    <div className="table-responsive" style={{maxHeight: '300px'}}>
                        <Table striped bordered hover size="sm" className="small text-center">
                            <thead className="table-secondary sticky-top">
                                <tr>
                                    <th>Loja</th>
                                    <th>Data Venda</th>
                                    <th>Data Crédito</th>
                                    <th>Valor Bruto</th>
                                    <th>Taxa %</th>
                                    <th>Valor Taxa</th>
                                </tr>
                            </thead>
                            <tbody>
                                {lancamentos.map((l, i) => (
                                    <tr key={i}>
                                        {/* Ajustado para ler campos que podem vir em MAIÚSCULO do Delphi */}
                                        <td>{l.LOJA || l.loja}</td>
                                        <td>{l.DATAVENDA || l.datavenda ? new Date(l.DATAVENDA || l.datavenda).toLocaleDateString() : '-'}</td>
                                        <td>{l.DATACREDITO || l.datacredito ? new Date(l.DATACREDITO || l.datacredito).toLocaleDateString() : '-'}</td>
                                        <td>R$ {Number(l.VALORBRUTO || l.valorbruto || 0).toFixed(2)}</td>
                                        <td>{Number(l.TAXA || l.taxa || 0).toFixed(2)}%</td>
                                        <td className="text-danger fw-bold">R$ {Number(l.VALORTAXA || l.valortaxa || 0).toFixed(2)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}